module.exports = __webpack_public_path__ + "static/media/alertIcon.9f82c240.svg";